import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import {
  NotificationUserType,
  useChannelHeader,
  useNotificationContext,
  useTitle,
} from '../hooks';
import { CellStyles, ChannelStyles, Item, Title } from './basics';

const Channels = styled.div`
  ${ChannelStyles};
`;

const Channel = styled.div`
  ${CellStyles};
`;

const Icon = styled.div`
  flex: 0 0 var(--layout-03);
  display: flex;
  align-items: center;
`;

const GroupName = styled(Title)`
  flex: 1 0 calc(55% - var(--layout-03));
`;

const Container = styled(Item)`
  font-weight: bold;
`;

const ChannelHeader: FC<{ channel: string }> = ({ channel }) => (
  <Channel>{useChannelHeader(channel)}</Channel>
);

interface Props {
  group: string;
  showHeaders?: boolean;
  options: string[];
  icon: ReactNode;
}

export const Header: FC<Props> = ({ group, showHeaders, options, icon }) => {
  const { isCustomerPortal } = useNotificationContext();

  const userType = isCustomerPortal
    ? NotificationUserType.Customer
    : NotificationUserType.Vendor;

  return (
    <Container>
      <Icon>{icon}</Icon>
      <GroupName>{useTitle(group, { userType })}</GroupName>
      <Channels>
        {!!showHeaders &&
          options.map((x) => <ChannelHeader key={x} channel={x} />)}
      </Channels>
    </Container>
  );
};
